module.exports = __webpack_public_path__ + "img/record-join-btn.49644595.png";